import { Link } from "react-router-dom";

const NewsList = (props) => {
    const {seminarId, title, date,url} = props;

    return(
        <>
            <a href={url} target="_blank" rel="noopener noreferrer" className="row collection-item lists">
                <div className="col s9">
                    <span className="list_title">
                        {title}
                    </span>
                </div>
                <div className="col s3">
                    <span className="list_date">
                        {date}
                    </span>
                </div>                
            </a>
        </>
    )
}

export default NewsList;